import { Box, Typography } from '@mui/material'
import { Dialog } from 'components/ui'
import { useMappedTranslation } from 'hooks'

export function GcrmDialog({ openDialog, handleOk, dialogState }) {
  const t = useMappedTranslation()

  return (
    <Dialog
      open={openDialog}
      PaperProps={{ sx: { bottom: 'unset' } }}
      contents={{
        title: dialogState?.notice?.title || '',
        content: (
          <>
            <Box>
              <Typography
                sx={{
                  textAlign: 'center',
                  whiteSpace: 'pre-line'
                }}
              >
                {dialogState?.notice?.description}
              </Typography>
              <br />
              <Typography sx={{ textAlign: 'center' }}>{dialogState?.notice?.schedule || ''}</Typography>
              <Typography sx={{ textAlign: 'center' }}>{dialogState?.notice?.unavailableServices || ''}</Typography>
            </Box>
          </>
        ),
        ok: t('iam.01.Common.Button.CONFIRM')
      }}
      titleSx={{ textAlign: 'center', fontSize: '30px' }}
      actionsSx={{ justifyContent: 'end' }}
      buttonSx={{ width: '56px !important' }}
      handleOk={handleOk}
    />
  )
}
